// scheduling/components/MatchBadge.jsx
// Colored pill showing the candidate's match tier on a recommendation surface.
// Used by StaffSuggestions and the PlaceholderAssignModal so both surfaces show
// the same visual.

export default function MatchBadge({ tier }) {
  const cfg = {
    client:      { bg: '#ECFDF5', text: '#065F46', label: '✓ Prior Client' },
    niche:       { bg: '#EFF6FF', text: '#1D4ED8', label: '~ Niche Match' },
    serviceline: { bg: '#F5F3FF', text: '#5B21B6', label: '◎ Service Line' },
    none:        { bg: '#F9FAFB', text: '#9CA3AF', label: 'New to Client Area' },
  }[tier] || { bg: '#F9FAFB', text: '#9CA3AF', label: 'No Match' };
  return <span className="sched-sug-match" style={{ background: cfg.bg, color: cfg.text }}>{cfg.label}</span>;
}
